import axios from "axios";
import React, { Component, Fragment } from "react";
import { Row, Col, Image, Button, Card, Form, Spinner } from "react-bootstrap";
import styles from "../../styles/box-widget.module.scss";
import { ReactComponent as IconBoxWidget } from "../../images/icon_box-widgets.svg";
import { ReactComponent as IconBoxWidgetMenuLisrt } from "../../images/icon_box-widgets-menu-list.svg";
import { ReactComponent as IconBoxWidgetMenu } from "../../images/icon_box-widgets-menu.svg";
import { ReactComponent as IconBoxWidgetMenuNotkBANK } from "../../images/icon_box-widgets-menu-notKBANK.svg";
import IconClose from "../../images/icon_box-widgets-close.svg";
import BoxWidgetsBody from "./boxWidgetsBody.js";
import { ReactComponent as IconCloseMenu } from "../../images/icon_box-widgets-menu-close.svg";
import { ReactComponent as IconHighlights } from "../../images/icon-highlights.svg";
import { ReactComponent as IconPlanSelect } from "../../images/icon-plan-select.svg";
import { ReactComponent as IconInsuranceCompare } from "../../images/icon-insurance-compare.svg";
import { ReactComponent as IconCoverageTerm } from "../../images/icon-coverage-term.svg";
import { ReactComponent as IconBenefit } from "../../images/icon-benefit.svg";
import { ReactComponent as IconFAQ } from "../../images/icon-FAQ.svg";
import { ReactComponent as IconIsDropLead } from "../../images/icon_isDropLead.svg";
import { ReactComponent as IconRemark } from "../../images/icon_remark.svg";

import MainData from "../../models/MainData.js";
import MainFunc from "../../models/MainFunc.js";

import IcoCallCenter from "../../images/ico_callcenter.png";
import { Collapse } from "@material-ui/core";
import IcoError from "../../images/ico_error.png";
import IcoCrossSign from "../../images/ico_closesign.png";
import IcoCorrect from "../../images/ico_correct.png";
import logo2 from "../../images/logo.png";
import IcoTelGreen from "../../images/ico_tel_green.png";
import Contact from "../../images/Contact.png";
import IconChatbot from "../../images/icon-chatbot.png";
import { ReactComponent as ContactIcon } from "../../images/contact_Icon.svg";
import { ReactComponent as KbankCallCenter } from "../../images/kbank_call_center.svg";
import { ReactComponent as Register } from "../../images/register.svg";
import { ReactComponent as Kbanklive } from "../../images/kbanklive.svg";
import { ReactComponent as Kplus } from "../../images/kplus.svg";
import { ReactComponent as VdoCallMB } from "../../images/vdo_call_mb.svg";
import moment from "moment";

class boxWidgetsMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMenu: false,
      IsSummaryDetailMobile: false,
      isOpen: false,
      autoOpen: false,
      channel: this.props.channel,
      showDropLead: false,
      step: "1",
      name: "",
      phoneNumber: "",
      email: "",
      selectDate: "",
      validateDroplead: false,
      nameerror: "",
      emailerror: "",
      failPhone: "",
      failselectDate: "",
      checkboxDroplead: false,
      checkInputname: false,
      checkInputemail: false,
      checkInputphoneNumber: false,
      showScreen: false,
      categoryGTM: "",
      actionGTM: "",
      labelGTM: "",
      scroll: 0,
      successInitialSale: false,
      NotfoundProduct: false,
      cookieCode: "",
      cookieVersionDisplay: "",
      cookieVersionOrder: 0,
      cookieDescription: "",
      cookieDescriptionCheck: false,
      device: "",
      openQR: false,
    };
  }

  handleButtonBoxWidgetsBody = () => {
    this.setState({ isOpen: !this.state.isOpen });
    if (this.state.isOpen === true) {
      this.setState({ autoOpen: true });
    }
  };

  serviceDroplead = () => {
    this.setState({
      nameerror: "",
      emailerror: "",
      failPhone: "",
      failselectDate: "",
    });
    this.setState({
      validateDroplead: true,
      checkInputname: false,
      checkInputemail: false,
    });
    let validate = false;
    if (
      !this.state.name ||
      !this.state.phoneNumber ||
      !this.state.email ||
      !this.state.selectDate
    ) {
      validate = true;
    }
    if (this.state.name === "") {
      this.setState({ nameerror: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (
      !this.state.name.split(/ (.*)/s)[0] ||
      !this.state.name.split(/ (.*)/s)[1]
    ) {
      this.setState({ nameerror: "กรุณาตรวจสอบข้อมูล", checkInputname: true });
      validate = true;
    }

    if (this.state.email === "") {
      this.setState({ emailerror: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (this.validateEmail(this.state.email) !== true) {
      this.setState({
        emailerror: "กรุณาตรวจสอบข้อมูล",
        checkInputemail: true,
      });
      validate = true;
    }

    if (this.state.phoneNumber == "") {
      this.setState({ failPhone: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (this.state.phoneNumber.length <= 9) {
      this.setState({
        failPhone: "กรุณาตรวจสอบข้อมูล",
        checkInputphoneNumber: true,
      });
      validate = true;
    }

    if (this.state.selectDate == "") {
      this.setState({ failselectDate: "กรุณาระบุข้อมูล" });
      validate = true;
    }

    if (validate) {
      return;
    }

    this.setState({ step: "2" });

    const headers = {
      Authorization: `Bearer ${MainData.initialData.bearerAuth}`,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT,DELETE",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
    };
    const data = {
      channel: MainData.initialData.channelCode,
      firstName: this.state.name.split(" ")[0].trim(),
      lastName: this.state.name.split(" ").slice(1).filter(Boolean).join(" "),
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
      productId: MainData.initialData.productId,
      contactTimeCode: this.state.selectDate,
    };

    axios
      .post(MainData.serviceURL + "/Customer/GetDropLead", data, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 299) {
          window.location.href = MainData.mainPath + "shutdown";
          return;
        }
        let data = res.data.data;
        if (res.data.success) {
          this.setState({ step: "3" });
          this.setState({
            contactTimeId: data.contactTimeId,
            contactTimeCode: data.contactTimeCode,
            contactTimeName: data.contactTimeName,
          });
        } else {
          this.setState({ step: "2" });
        }
      })
      .catch((error) => {
        if (error?.response?.status == 400) {
          this.loadController(false);
          this.validateBadRequest(error.response.data.errors);
        } else {
          this.setState({ step: "4" });
        }
      });
  };

  validateBadRequest = (fieldNameList) => {
    let errMsg = MainData.masterMessage.find((x) => x.msgCode === "MSG018");
    this.errorAlert(
      true,
      !errMsg ? "กรุณาตรวจสอบข้อมูล" : errMsg.msgDescription,
      " "
    );
    if (
      fieldNameList.find((data) => data.field === "firstName") ||
      fieldNameList.find((data) => data.field === "lastName")
    ) {
      this.setState({ nameerror: errMsg, checkInputname: true });
    }
    if (fieldNameList.find((data) => data.field === "phoneNumber")) {
      this.setState({ failPhone: errMsg, checkInputphoneNumber: true });
    }
    if (fieldNameList.find((data) => data.field === "email")) {
      this.setState({ emailerror: errMsg, checkInputemail: true });
    }
    if (fieldNameList.find((data) => data.field === "contactTimeCode")) {
      this.setState({ failselectDate: errMsg });
    }
  };
  serviceDroplead = () => {
    this.setState({
      nameerror: "",
      emailerror: "",
      failPhone: "",
      failselectDate: "",
    });
    this.setState({
      validateDroplead: true,
      checkInputname: false,
      checkInputemail: false,
      checkInputemail: false,
    });
    let validate = false;
    if (
      !this.state.name ||
      !this.state.phoneNumber ||
      !this.state.email ||
      !this.state.selectDate
    ) {
      validate = true;
    }
    if (this.state.name === "") {
      this.setState({ nameerror: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (
      !this.state.name.split(/ (.*)/s)[0] ||
      !this.state.name.split(/ (.*)/s)[1]
    ) {
      this.setState({ nameerror: "กรุณาตรวจสอบข้อมูล", checkInputname: true });
      validate = true;
    }

    if (this.state.email === "") {
      this.setState({ emailerror: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (this.validateEmail(this.state.email) !== true) {
      this.setState({
        emailerror: "กรุณาตรวจสอบข้อมูล",
        checkInputemail: true,
      });
      validate = true;
    }

    if (this.state.phoneNumber == "") {
      this.setState({ failPhone: "กรุณาระบุข้อมูล" });
      validate = true;
    } else if (this.state.phoneNumber.length <= 9) {
      this.setState({
        failPhone: "กรุณาตรวจสอบข้อมูล",
        checkInputphoneNumber: true,
      });
      validate = true;
    }

    if (this.state.selectDate == "") {
      this.setState({ failselectDate: "กรุณาระบุข้อมูล" });
      validate = true;
    }

    if (validate) {
      return;
    }

    this.setState({ step: "2" });

    const headers = {
      Authorization: `Bearer ${MainData.initialData.bearerAuth}`,
      "Content-Type": "application/json;charset=UTF-8",
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Credentials": "true",
      "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT,DELETE",
      "Access-Control-Allow-Headers":
        "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers",
    };
    const data = {
      channel: MainData.initialData.channelCode,
      firstName: this.state.name.split(" ")[0].trim(),
      lastName: this.state.name.split(" ").slice(1).filter(Boolean).join(" "),
      phoneNumber: this.state.phoneNumber,
      email: this.state.email,
      productId: MainData.initialData.productId,
      contactTimeName: this.state.selectDate,
    };

    axios
      .post(MainData.serviceURL + "/Customer/GetDropLead", data, {
        headers: headers,
      })
      .then((res) => {
        if (res.status === 299) {
          window.location.href = MainData.mainPath + "shutdown";
          return;
        }
        let data = res.data.data;
        if (res.data.success) {
          this.setState({ step: "3" });
          this.setState({
            contactTimeId: data.contactTimeId,
            contactTimeCode: data.contactTimeCode,
            contactTimeName: data.contactTimeName,
          });
        } else {
          this.setState({ step: "2" });
        }
      })
      .catch((error) => {
        if (error?.response?.status == 400) {
          this.loadController(false);
          this.validateBadRequest(error.response.data.errors);
        } else {
          this.setState({ step: "4" });
        }
      });
  };

  validateBadRequest = (fieldNameList) => {
    let errMsg = MainData.masterMessage.find((x) => x.msgCode === "MSG018");
    this.errorAlert(
      true,
      !errMsg ? "กรุณาตรวจสอบข้อมูล" : errMsg.msgDescription,
      " "
    );
    if (
      fieldNameList.find((data) => data.field === "firstName") ||
      fieldNameList.find((data) => data.field === "lastName")
    ) {
      this.setState({ nameerror: errMsg, checkInputname: true });
    }
    if (fieldNameList.find((data) => data.field === "phoneNumber")) {
      this.setState({ failPhone: errMsg, checkInputphoneNumber: true });
    }
    if (fieldNameList.find((data) => data.field === "email")) {
      this.setState({ emailerror: errMsg, checkInputemail: true });
    }
    if (fieldNameList.find((data) => data.field === "contactTimeCode")) {
      this.setState({ failselectDate: errMsg });
    }
  };

  validateEmail = (email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  handleInputChange = (name, val) => {
    switch (name) {
      case "name":
        if (val[0] === " ") {
          break;
        }
        let checkWord = /^[ก-์ ()]+$/.test(val);
        this.setState((state) => ({
          name: !checkWord && val ? state.name : val,
        }));
        this.setState({ checkInputname: false });
        if (this.state.name.split(" ")[0] || this.state.name.split(" ")[1]) {
          this.setState({ nameerror: "" });
        }
        break;
      case "phoneNumber":
        val = val.replace(/[^\d]/g, "");
        if (val.length === 1 && val !== "0") {
          this.setState({ phoneNumber: "0" + val });
        } else if (val.length <= 10) {
          this.setState({ phoneNumber: val, failPhone: "" });
        }
        this.setState({ checkInputphoneNumber: false });
        break;
      case "email":
        let checkWord4 = /^[a-zA-Z0-9-@_.]+$/.test(val);
        this.setState((state) => ({
          email: !checkWord4 && val ? state.email : val,
          emailerror: "",
        }));
        this.setState({ checkInputemail: false });
        break;
      case "selectDate":
        this.setState({ selectDate: val, failselectDate: "" });
        break;
      default:
        break;
    }
  };

  closeDroplead = () => {
    this.setState({
      showDropLead: false,
      step: "1",
      validateDroplead: false,
      checkboxDroplead: false,
      checkInputname: false,
      checkInputemail: false,
      checkInputphoneNumber: false,
    });
    this.setState({ name: "", phoneNumber: "", email: "", selectDate: "" });
    this.setState({
      nameerror: "",
      failPhone: "",
      emailerror: "",
      failselectDate: "",
      validateDroplead: false,
    });
  };

  getQR = () => {
    const headers = {
      Authorization: `Bearer ${MainData.initialData.bearerAuth}`,
      "language-locale": "th",
    };
    const data = {
      productId: MainData.initialData?.productId,
      planId: MainData.userSelectedData?.selectedPlan?.planId
        ? MainData.userSelectedData?.selectedPlan?.planId
        : MainData.screenSM002.planId,
      gender: MainData.dataBroker.gender
        ? MainData.screenSM001.gender
          ? MainData.screenSM001.gender
          : MainData.dataBroker.gender
        : MainData.screenSM001.gender
        ? MainData.screenSM001.gender
        : "",
      age:
        MainData.dataBroker?.birthdateQR?.length == 10
          ? MainData.screenSM001.birthdate?.length == 10
            ? moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
            : moment().format("YYYY") -
              parseInt(MainFunc.getUserBirthDateQR("ac")?.split("-")[0])
          : MainData.screenSM001.birthdate?.length == 10
          ? moment().format("YYYY") -
            parseInt(MainFunc.getUserBirthDate("ac")?.split("-")[0])
          : null,
    };
    axios
      .post(MainData.serviceURL + "/Broker/GenBotLineLink", data, { headers })
      .then(async (response) => {
        // handle success
        window.location.href = response.data.botlineLink;
      })
      .catch((error) => {
        console.log(error);
        let errMsg = MainData.masterMessage.find(
          (x) => x.msgCode === "MSG1001"
        );
        this.props.errorAlert(
          true,
          !errMsg
            ? "พบปัญหาในการเชื่อมต่อไปยัง service กรุณาติดต่อผู้ดูแลระบบ"
            : errMsg.msgDescription.replace(
                "{{Service}}",
                error.response.data.data?.messageDescription
              ),
          " "
        );
        this.props.loadController(false);
      });
  };
  render() {
    return (
      // JSX code for rendering your component
      <Fragment>
        <div
          className={`${styles.menuList} ${
            this.state.isOpenMenu ? styles.activeMenu : ""
          }`}
        >
          <div
            className={`${styles.menuListBody} ${
              this.state.isOpenMenu ? styles.activeMenu : ""
            }`}
          >
            <div
              className={styles.title}
              onClick={() => this.setState({ isOpenMenu: false })}
            >
              <p>{MainFunc.getLabelDtos("L0814") /*แตะเพื่อปิด*/}</p>
            </div>
            <div className={styles.menuTitleNav}>
              <img src={Contact} />
              <div>
                <p className={styles.title}>
                  <strong>
                    {MainFunc.getLabelDtos("L0764") /*ปรึกษาผู้เชี่ยวชาญ*/}
                  </strong>
                </p>
                <p className={styles.contact}>
                  {
                    MainFunc.getLabelDtos(
                      "L0887"
                    ) /*รับคำอธิบายพร้อมปรึกษาแบบประกันที่ เหมาะสมที่สุดสำหรับคุณ*/
                  }
                </p>
              </div>
            </div>
            <span
              id="mb_contact_linechat"
              className={styles.menuContentNav}
              href={this.props.contactWidget?.contactKbankLive}
              onClick={() => {
                if (this.props.activePage) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: "chatbox",
                    event_label: "line_chat",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0790") +
                      "_" +
                      MainFunc.getLabelDtos("L0791").replace(/ /g, "_"), // ส่งตามชื่อที่หน้าจอ
                  });
                } else {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: "chatbox",
                    event_label: "line_chat",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0790") +
                      "_" +
                      MainFunc.getLabelDtos("L0791").replace(/ /g, "_"), // ส่งตามชื่อที่หน้าจอ
                  });
                }
                this.getQR();
              }}
            >
              <div>{this.props.channel?.css && <Kbanklive />}</div>
              <p>
                {MainFunc.getLabelDtos("L0790") /*แชทกับผู้เชี่ยวชาญผ่าน*/}{" "}
                <strong>
                  {MainFunc.getLabelDtos("L0791") /*Line KBank Live*/}
                </strong>
              </p>
            </span>
            <span
              id="mb_contact_callkplus"
              className={styles.menuContentNav}
              onClick={() => {
                if (this.props.activePage) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "wifi_calling_via_kplus",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0888").replace(/ /g, "_") +
                      "_" +
                      MainFunc.getLabelDtos("L0889").replace(/ /g, "_"),
                  });
                } else {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "wifi_calling_via_kplus",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0888").replace(/ /g, "_") +
                      "_" +
                      MainFunc.getLabelDtos("L0889").replace(/ /g, "_"),
                  });
                }
                if (this.state.device) {
                  window.location.href =
                    this.props.contactWidget?.contactWifiMb;
                } else {
                  window.location.href =
                    this.props.contactWidget?.contactWifiPc;
                }
              }}
            >
              <div>{this.props.channel?.css && <Kplus />}</div>
              <p class="text-inner">
                {MainFunc.getLabelDtos("L0888") /*คุยกับผู้เชี่ยวชาญผ่าน*/}{" "}
                <strong class="c-green">
                  {MainFunc.getLabelDtos("L0889") /*KPlus (ฟรี!)*/}
                </strong>{" "}
              </p>
            </span>
            <a
              id="mb_contact_call24"
              href={`tel:${this.props.contactWidget?.contactPhoneNumber}`}
              onClick={() => {
                if (this.props.activePage) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "hotline_contact_center",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0888").replace(/ /g, "_") +
                      "_" +
                      MainFunc.getLabelDtos("L0890").replace(/ /g, "_"),
                  });
                } else {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: " link_click",
                    event_label: "hotline_contact_center",
                    element_grouping: "icon",
                    element_section: "assistance",
                    element_title:
                      MainFunc.getLabelDtos("L0888").replace(/ /g, "_") +
                      "_" +
                      MainFunc.getLabelDtos("L0890").replace(/ /g, "_"),
                  });
                }
              }}
              className={styles.menuContentNav}
            >
              <div>{this.props.channel?.css && <KbankCallCenter />}</div>
              <p class="text-inner">
                {MainFunc.getLabelDtos("L0888") /*คุยกับผู้เชี่ยวชาญผ่าน*/}{" "}
                <strong class="c-green">
                  {
                    MainFunc.getLabelDtos(
                      "L0890"
                    ) /*Kbank Call Center 02-8888888 กด 862*/
                  }
                </strong>{" "}
              </p>
            </a>
            {MainData.screenDetail.vdoCallStatus && (
              <a
                id="mb_contact_vdo-call"
                href={MainData.screenDetail.vdoCallUrl}
                onClick={() => {
                  if (this.props.activePage) {
                    MainFunc.sendDataToGTMKbank({
                      event: "track_event",
                      event_category: " link_click",
                      event_label: "vdo_call",
                      element_grouping: "icon",
                      element_section: "assistance",
                      element_title:
                        MainFunc.getLabelDtos("L0893").replace(/ /g, "_") +
                        "_" +
                        MainFunc.getLabelDtos("L0894").replace(/ /g, "_"),
                    });
                  } else {
                    MainFunc.sendDataToGTMKbank({
                      event: "track_event",
                      event_category: " link_click",
                      event_label: "vdo_call",
                      element_grouping: "icon",
                      element_section: "assistance",
                      element_title:
                        MainFunc.getLabelDtos("L0893").replace(/ /g, "_") +
                        "_" +
                        MainFunc.getLabelDtos("L0894").replace(/ /g, "_"),
                    });
                  }
                }}
                className={styles.menuContentNav}
              >
                <div>{this.props.channel?.css && <VdoCallMB />}</div>
                <p class="text-inner">
                  {MainFunc.getLabelDtos("L0893") /*คุยกับเจ้าหน้าที่*/}{" "}
                  <strong class="c-green">
                    {MainFunc.getLabelDtos("L0894") /*VDO Call*/}
                  </strong>{" "}
                </p>
              </a>
            )}

            {this.props.data?.isDropLead && (
              <div
                id="mb_contact_fill"
                className={styles.menuContentNav}
                onClick={() => {
                  this.props.setActiveCompornent("isDropLead", true, true);
                  this.setState({ isOpenMenu: false });
                  if (this.props.activePage) {
                    MainFunc.sendDataToGTMKbank({
                      event: "track_event",
                      event_category: "anchor",
                      event_label: "contact_to_apply",
                      element_grouping: "icon",
                      element_section: "assistance",
                      element_title: MainFunc.getLabelDtos("L0891").replace(
                        / /g,
                        "_"
                      ),
                    });
                  } else {
                    MainFunc.sendDataToGTMKbank({
                      event: "track_event",
                      event_category: "anchor",
                      event_label: "contact_to_apply",
                      element_grouping: "icon",
                      element_section: "assistance",
                      element_title: MainFunc.getLabelDtos("L0891").replace(
                        / /g,
                        "_"
                      ),
                    });
                  }
                }}
              >
                {this.props.channel?.css && <Register />}
                <p class="text-inner">
                  {
                    MainFunc.getLabelDtos(
                      "L0891"
                    ) /*กรอกข้อมูล เพื่อให้ผู้เชี่ยวชาญติดต่อกลับ*/
                  }
                </p>
              </div>
            )}
          </div>
        </div>

        {MainData.userSelectedData.selectedPlan &&
          !MainData.brokerPlan.disableBtnPlanSumary &&
          this.props.stepSelectPlan !== 3 && (
            <div className={styles.summaryMobile}>
              <div className={styles.btnShowDetail}>
                <a
                  onClick={() =>
                    this.setState({
                      IsSummaryDetailMobile: !this.state.IsSummaryDetailMobile,
                    })
                  }
                  className={styles.showDetail}
                  title="แสดงรายละเอียดเพิ่มเติม"
                >
                  {
                    !this.state.IsSummaryDetailMobile
                      ? MainFunc.getLabelDtos("L0813") /*แตะเพื่อดูรายละเอียด*/
                      : MainFunc.getLabelDtos("L0814") /*แตะเพื่อปิด*/
                  }
                </a>
              </div>
              <div
                className={`${styles.summaryDetailMobile} ${
                  this.state.IsSummaryDetailMobile ? styles.activeMenu : ""
                }`}
              >
                <div className="container">
                  <div className={styles.detailContent}>
                    <div className={styles.contentPlanSelected}>
                      <div className={styles.dataTitle}>
                        <div className={styles.title}>
                          {MainFunc.getLabelDtos("L0722") /*เบี้ยกรมธรรม์หลัก*/}
                        </div>
                        <div className={styles.value}>
                          {" "}
                          {MainFunc.numberWithCommas(
                            MainData.userSelectedData.notRiderPlan?.premium
                          ) +
                            " " +
                            MainFunc.getLabelDtos("L0104")}
                        </div>
                      </div>
                    </div>
                    {MainData.dataBroker.planInfo?.planDetails?.map((data) => {
                      return (
                        <div className={styles.contentPlanSelected}>
                          <div className={styles.dataGroup}>
                            {data?.groupTitle && (
                              <div
                                className={styles.title}
                                dangerouslySetInnerHTML={{
                                  __html: data?.groupTitle,
                                }}
                              ></div>
                            )}
                            {data?.groupValue && (
                              <div
                                className={styles.value}
                                dangerouslySetInnerHTML={{
                                  __html: data?.groupValue,
                                }}
                              ></div>
                            )}
                          </div>
                          {data.titles.map((item, index) => {
                            return (
                              <Fragment>
                                <div className={styles.dataTitle}>
                                  {item.title && (
                                    <div
                                      className={styles.title}
                                      dangerouslySetInnerHTML={{
                                        __html: item.title,
                                      }}
                                    ></div>
                                  )}
                                  {item.titleValue && (
                                    <div
                                      className={styles.value}
                                      dangerouslySetInnerHTML={{
                                        __html: item.titleValue,
                                      }}
                                    ></div>
                                  )}
                                </div>
                                {item.subTitles?.map((subItem, subIndex) => {
                                  return (
                                    <div className={styles.dataSubTitle}>
                                      <div
                                        className={styles.title}
                                        dangerouslySetInnerHTML={{
                                          __html: subItem.subTitle,
                                        }}
                                      ></div>
                                      <div className={styles.value}>
                                        <div
                                          className={styles.title}
                                          dangerouslySetInnerHTML={{
                                            __html: subItem.subTitleValue,
                                          }}
                                        />
                                      </div>
                                    </div>
                                  );
                                })}
                              </Fragment>
                            );
                          })}
                          <div className={styles.rowline}></div>
                        </div>
                      );
                    })}
                  </div>
                  {/* บริการเสริม */}
                  {MainData.dataBroker.riderPlan?.map((riderPlan, index) => (
                    <div className={styles.detailContent}>
                      <div className={styles.contentPlanSelected}>
                        <div className={styles.dataGroupRider}>
                          {riderPlan?.groupDescription && (
                            <div className={styles.title}>
                              {riderPlan?.groupDescription}
                            </div>
                          )}
                        </div>
                        <div>
                          {riderPlan.riderBenefits?.map((riderBenefits) => {
                            if (
                              MainData.dataBroker.selectRider.includes(
                                riderBenefits.riderCode
                              )
                            ) {
                              return (
                                <Col
                                  md={4}
                                  className={styles.additionalServicesData}
                                >
                                  <div className={styles.dataTitleRider}>
                                    {riderBenefits.riderName && (
                                      <span className={styles.title}>
                                        {riderBenefits.riderName}
                                      </span>
                                    )}
                                    {riderBenefits.titleValue && (
                                      <span className={styles.value}>
                                        {riderBenefits.titleValue}
                                      </span>
                                    )}
                                  </div>
                                  <div className={styles.dataSubTitleRider}>
                                    <span className={styles.title}>
                                      {riderBenefits.riderTitle}{" "}
                                      {MainFunc.numberWithCommas(
                                        riderBenefits?.riderPremium
                                      ) +
                                        " " +
                                        MainFunc.getLabelDtos("L0104")}
                                      /
                                      {
                                        MainData.userSelectedData?.selectedPlan
                                          ?.paymentUnitTitle
                                      }
                                    </span>
                                    <span className={styles.value}></span>
                                  </div>
                                </Col>
                              );
                            }
                          })}
                          {riderPlan.riderSpecials?.map((riderSpecial) => (
                            <Col
                              md={4}
                              className={styles.additionalServicesData}
                            >
                              <div className={styles.dataTitleRiderSpecial}>
                                {riderSpecial.riderSpecialName && (
                                  <span className={styles.title}>
                                    {riderSpecial.riderSpecialName}
                                  </span>
                                )}
                              </div>
                              <div className={styles.dataSubTitleRiderSpecial}>
                                <span className={styles.title}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: riderSpecial.riderSpecialTitle,
                                    }}
                                  ></div>
                                </span>
                                <span className={styles.value}>
                                  <div
                                    dangerouslySetInnerHTML={{
                                      __html: riderSpecial.riderSpecialValue,
                                    }}
                                  ></div>
                                </span>
                              </div>
                            </Col>
                          ))}
                        </div>
                      </div>
                      <div className={styles.rowline}></div>
                    </div>
                  ))}
                </div>
              </div>
              {MainData.userSelectedData.selectedPlan && (
                <div className="container">
                  <div className={styles.mainContent}>
                    <div className={styles.left}>
                      <div className={styles.productName}>
                        {
                          MainFunc.getLabelDtos(
                            "L0765"
                          ) /*แผนประกันที่คุณเลือก*/
                        }
                      </div>
                      <div className={styles.productName}>
                        {MainData.dataBroker.planInfo?.productName}{" "}
                        {MainData.userSelectedData.selectedPlan?.planName}
                      </div>
                    </div>
                    <div className={styles.right}>
                      <div className={styles.paymentType}>
                        {MainFunc.getLabelDtos("L0726") /*เบี้ยรวมต่อ*/}
                        {
                          MainData.userSelectedData.selectedPlan
                            ?.paymentUnitTitle
                        }
                      </div>
                      <div className={styles.premium}>
                        {" "}
                        {MainFunc.numberWithCommas(
                          MainData.userSelectedData.selectedPlan?.premium
                        ) +
                          " " +
                          MainFunc.getLabelDtos("L0104")}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}

        <div className={styles.boxWidgetsMobile}>
          {this.props.channel?.css && (
            <div
              id="floatbar_consult"
              className={`${styles.mainIcon} ${styles.menulistIcon}`}
              onClick={() => {
                if (!this.state.isOpenMenu) {
                  MainFunc.sendDataToGTMKbank({
                    event: "track_event",
                    event_category: "accordion_content",
                    event_label: "contact_center",
                    element_grouping: "nav_menu",
                    element_section: "floating_nav_menu",
                    element_title:
                      MainFunc.getLabelDtos("L0764") /*ปรึกษาผู้เชี่ยวชาญ*/,
                  });
                }
                this.setState({ isOpenMenu: !this.state.isOpenMenu });
              }}
            >
              {this.props.channel?.css && (
                <ContactIcon style={{ marginRight: "8px" }} />
              )}
              <a>{MainFunc.getLabelDtos("L0764") /*ปรึกษาผู้เชี่ยวชาญ*/}</a>
            </div>
          )}

          <div style={{ width: "50%" }}>
            <button
              id={
                this.props.stepSelectPlan === 3
                  ? `floatbar_buynow_${this.props.productKeyAd}`
                  : "floatbar_calulate"
              }
              onClick={() => this.props.onProcessData()}
              className={styles.btnInsure}
              title="ติดต่อเลย"
              disabled={MainData.brokerPlan.disableBtnPlanSumary}
            >
              {
                this.props.stepSelectPlan === 1 &&
                  MainFunc.getLabelDtos("L0770") /*คำนวณเบี้ยของคุณ*/
              }
              {
                this.props.stepSelectPlan === 2 &&
                  MainFunc.getLabelDtos("L0809") /*สรุปข้อมูลแผนประกัน*/
              }
              {
                this.props.stepSelectPlan === 3 &&
                  MainFunc.getLabelDtos("L0768") /*ซื้อเลย*/
              }
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default boxWidgetsMobile;
